/*
 * Copyright (c) 2019 by Orange Polska S.A.
 * This software is the proprietary information of Orange Polska S.A.
 *
 * All rights reserved.
 */

"use strict";
(function(global) {
    class StopPhishingOperatorReportsController {
        constructor(config) {
            this.settings = {
                charts: {
                    barChart: {
                        dataName: "column_data",
                        id: "alarms"
                    }
                },
                colors: {
                    low: "250, 220, 0",
                    medium: "255, 132, 51",
                    high: "213, 71, 51"
                }
            }
            this.init(config);
        }

        init(config) {
            this.createGrid(config);
        }

        createGrid(config) {
            const columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
                "columnDefinitions": [{
                    "label": "Data",
                    "dataIndex": "date",
                    "dataType": "text",
                    "isEditable": false,
                    "isSortable": true,
                    "isFilterable": true,
                    "isMovable": true,
                    "width": "100px"
                }, {
                    "label": "Firma",
                    "dataIndex": "firm",
                    "dataType": "text",
                    "isEditable": false,
                    "width": "*"
                }, {
                    "label": "Nazwa pliku",
                    "dataIndex": "file_name",
                    "dataType": "text",
                    "isEditable": false,
                    "width": "*"
                }, {
                    "label": "Opis raportu",
                    "dataIndex": "description",
                    "dataType": "text",
                    "isEditable": false,
                    "width": "*"
                }, {
                    "label": "Akcje",
                    "dataIndex": "actions",
                    "dataType": "actions",
                    "isEditable": false,
                    "isFilterable": false,
                    "isSortable": false,
                    "width": "300px"
                }]
            });

            const dataSource = new NS.Grid.SimpleDataSource({
                'url': config.table_data_url,
                'baseParameters': {},
                'updateUrl': "/js/app/update.json"
            });

            const settingsManager = new NS.Grid.CookiesSettingsManager({
                "id": "gridContainerId"
            });

            new NS.Grid.Control({
                'id': "gridContainerWrapperId",
                'containerId': 'grid-container',
                'dataSource': dataSource,
                'reloadTime': null, //not implemented yet
                'autoLoad': true,
                'columnDefinitionSource': columnDefinitionSource,
                'settingsManager': settingsManager,
                'allowMultiselect': false,
                "showAllRows" : config.show_all_rows || false,
                "pageSize": (config.show_all_rows)? 99999999 : 20,
                'listeners': {
                    'onDataChanged': function() {

                    },
                    'onDataSaved': function() {

                    },
                    'onDataInvalid': function() {

                    },
                    'onDataError': function() {

                    },
                    'onSelectionChange': function(ids) {

                    }
                }
            });
        }
    }

    //wyeksportowanie klasy
    global.NS = global.NS || {};
    global.NS.Views = global.NS.Views || {};
    global.NS.Views.StopPhishingOperatorReportsController = StopPhishingOperatorReportsController || {};

})(window);
